import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { ButtonGroup } from '@material-ui/core';

const styles = theme => ({});

const AfitdButtonGroup = props => {
    const { classes, isHidden, children, className, ...otherProps } = props;

    if (isHidden) {
        return null;
    } else {
        return (
            <ButtonGroup disableElevation variant="contained" className={className} classes={classes} {...otherProps}>
                {children}
            </ButtonGroup>
        );
    }
};

export default withStyles(styles)(AfitdButtonGroup);
